<script setup lang="ts">
useHead({
  title: 'Cantook Access',
});

const route = useRoute();

const layout = computed(() =>
  route.fullPath.split('/')[1] === 'app' ? 'default' : 'pages',
);
</script>

<template>
  <div>
    <LoadingTopBar />
    <NuxtRouteAnnouncer />
    <UApp :toaster="{ position: 'bottom-left', progress: false }">
      <NuxtLayout :name="layout">
        <NuxtPage :transition="true" :keepalive="true" />
      </NuxtLayout>
    </UApp>
  </div>
</template>
